import axiosInstance from './axiosInstance';
import { Absence, CreateAbsenceDto, UpdateAbsenceDto, ApproveAbsenceDto, AbsenceSummary, AbsenceFilters } from '../types/absences.types';

const API_URL = '/Absences';

export const absencesService = {
  getAll: async (filters?: AbsenceFilters): Promise<Absence[]> => {
    const params = new URLSearchParams();
    if (filters?.branchId) params.append('branchId', filters.branchId.toString());
    if (filters?.employeeId) params.append('employeeId', filters.employeeId.toString());
    if (filters?.fromDate) params.append('fromDate', filters.fromDate);
    if (filters?.toDate) params.append('toDate', filters.toDate);
    if (filters?.status) params.append('status', filters.status);

    const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<Absence> => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },

  getByEmployee: async (employeeId: number, fromDate?: string, toDate?: string): Promise<Absence[]> => {
    const params = new URLSearchParams();
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    const response = await axiosInstance.get(`${API_URL}/employee/${employeeId}?${params.toString()}`);
    return response.data;
  },

  getSummary: async (branchId?: number, fromDate?: string, toDate?: string): Promise<AbsenceSummary[]> => {
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    const response = await axiosInstance.get(`${API_URL}/summary?${params.toString()}`);
    return response.data;
  },

  create: async (data: CreateAbsenceDto): Promise<Absence> => {
    const response = await axiosInstance.post(`${API_URL}`, data);
    return response.data;
  },

  update: async (data: UpdateAbsenceDto): Promise<Absence> => {
    const response = await axiosInstance.put(`${API_URL}/${data.absenceId}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  acknowledge: async (id: number): Promise<Absence> => {
    const response = await axiosInstance.post(`${API_URL}/${id}/acknowledge`);
    return response.data;
  },

  approve: async (data: ApproveAbsenceDto): Promise<Absence> => {
    const response = await axiosInstance.post(`${API_URL}/approve`, data);
    return response.data;
  }
};